/**
 * @deprecated Use optional chaining instead
 */
export function SquashNulls(object, property, subProperty) {
  var object = arguments[0];
  if (object == null) {
    return '';
  }
  for (var i = 1; i < arguments.length; i++) {
    object = object[arguments[i]];
    if (object == null) {
      return '';
    }
  }
  return object;
}
